import isLikeNull from '../sanitization/isLikeNull';
import { RepliersListingLotMeasurementUnits } from '../../types/repliers/RepliersListingLotMeasurementUnits';
import round from '../round';
import feetToMetres from '../conversions/feetToMetres';

export function convertLotMeasurementsToMetres(
  distance: string | null,
  measurementUnits: null | string,
  mlsNumber: string, // For error logging purposes
): number | null {
  if (
    isLikeNull(distance) ||
    isNaN(Number(distance)) ||
    isLikeNull(measurementUnits)
  ) {
    return null;
  }
  switch (measurementUnits) {
    case RepliersListingLotMeasurementUnits.Metres:
    case RepliersListingLotMeasurementUnits.Me:
    case RepliersListingLotMeasurementUnits.Square_Meters:
      return Number(distance);
    case RepliersListingLotMeasurementUnits.Feet:
    case RepliersListingLotMeasurementUnits.Foot:
    case RepliersListingLotMeasurementUnits.Fe:
    case RepliersListingLotMeasurementUnits.Ft:
    case RepliersListingLotMeasurementUnits.F:
    case RepliersListingLotMeasurementUnits.Sq_Ft:
    case RepliersListingLotMeasurementUnits.Sq_Ft_Divisible:
    case RepliersListingLotMeasurementUnits.Square_Feet:
      return round(feetToMetres(Number(distance)), 6);
    case RepliersListingLotMeasurementUnits.Acres:
    case RepliersListingLotMeasurementUnits.Acres1:
    case RepliersListingLotMeasurementUnits.Acres2:
    case RepliersListingLotMeasurementUnits.Hectares:
      // Not sure how to handle Acres or Hectares...
      return null;
    default:
      // A new unexpected type!
      console.log(
        `Failed to convert lot distances on unhandled type ${measurementUnits} for listing ${mlsNumber}`,
      );
      return null;
  }
}
